import React from "react";
import { FaShoppingBag, FaTable } from "react-icons/fa";
import { MdRestaurantMenu } from "react-icons/md";

const DineInCard = ({
  gradientColor,
  landingPageCardTextColor,
  landingPageCardFontSize,
  landingPageCardBorderColor,
  landingPageCardIconColor,
  landingPageSelectedCardBorderColor,
}) => {
  return (
    <div
      style={{
        background: `linear-gradient(${gradientColor})`,
        padding: "20px",
        borderRadius: "10px",
        border: `1px solid ${landingPageSelectedCardBorderColor}`,
        width: "50%",
        flexDirection: "column",
        marginBottom: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        fontWeight: "bold",
        boxSizing: "border-box",
      }}
    >
      <MdRestaurantMenu  size={15} color={landingPageCardIconColor} />
      <div
        color={landingPageCardTextColor}
        fontSize={`${landingPageCardFontSize}px`}
      >
        Dine-In
      </div>
      
    </div>
  );
};

const TakeawayCard = ({
  gradientColor,
  landingPageCardTextColor,
  landingPageCardFontSize,
  landingPageCardBorderColor,
  landingPageCardIconColor,
  landingPageSelectedCardBorderColor,
}) => {
  return (
    <div
      style={{
        background: `linear-gradient(${gradientColor})`,
        padding: "20px",
        borderRadius: "10px",
        width: "50%",
        marginBottom: "10px",
        border: `1px solid ${landingPageCardBorderColor}`,
        display: "flex",
        justifyContent: "center",
        flexDirection: "column",
        alignItems: "center",
        fontWeight: "bold",
        boxSizing: "border-box",
      }}
    >
      <FaShoppingBag size={15} color={landingPageCardIconColor} />
      <div
        color={landingPageCardTextColor}
        fontSize={`${landingPageCardFontSize}px`}
      >
        Takeaway
      </div>
    </div>
  );
};

const LandingPage = ({
  gradientColors,
  welcomeTextColor,
  welcomeFontSize,
  instructionTextColor,
  instructionFontSize,
  landingPageCardGradientColor, // Added new gradient prop for the cards
  landingPageCardTextColor,
  landingPageCardFontSize,
  landingPageCardBorderColor,
  landingPageCardIconColor,
  landingPageSelectedCardBorderColor,
  landingPageLanguageTextColor,
  landingPageSelectedLanguageTextColor,
  landingPageLanguageButtonBorderColor,
  landingPageSelectedLanguageButtonBorderColor,
  landingPageDeviceIdTextColor,
  landingPageErrorTextColor,
  landingPageErrorIconColor,
}) => {
  return (
    <div
      style={{
        width: "100%",
        height: "550px",
        background: `linear-gradient(${gradientColors})`,
        padding: "20px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        alignSelf: "center",
        borderRadius: "20px",
        fontFamily: "Arial, sans-serif",
        boxSizing: "border-box",
        transition: "all 0.3s ease",
      }}
    >
      <div
        style={{
          fontSize: `${welcomeFontSize}px`,
          fontWeight: "bold",
          textAlign: "center",
          color: welcomeTextColor,
        }}
      >
        Welcome
      </div>
      <div
        style={{
          fontSize: `${instructionFontSize}px`,
          marginTop: "10px",
          color: instructionTextColor,
          textAlign: "center",
        }}
      >
        Please select your order type and language
      </div>
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          flexDirection: "row",
          gap: "10px",
          width: "100%",
          color: landingPageCardTextColor,
        }}
      >
        {/* Dine-In and Takeaway Cards */}
        <DineInCard
          gradientColor={landingPageCardGradientColor}
          landingPageCardTextColor={landingPageCardTextColor}
          landingPageCardFontSize={landingPageCardFontSize}
          landingPageCardBorderColor={landingPageCardBorderColor}
          landingPageCardIconColor={landingPageCardIconColor}
          landingPageSelectedCardBorderColor={
            landingPageSelectedCardBorderColor
          }
        />
        <TakeawayCard
          gradientColor={landingPageCardGradientColor}
          landingPageCardTextColor={landingPageCardTextColor}
          landingPageCardFontSize={landingPageCardFontSize}
          landingPageCardBorderColor={landingPageCardBorderColor}
          landingPageCardIconColor={landingPageCardIconColor}
          landingPageSelectedCardBorderColor={
            landingPageSelectedCardBorderColor
          }
        />
      </div>
      <div
        style={{
          marginTop: "30px",
          display: "flex",
          flexDirection: "column",
          gap: "10px",
          width: "100%",
        }}
      >
        <button
          style={{
            backgroundColor: "transparent",
            color: `${landingPageLanguageTextColor}`,
            padding: "10px 20px",
            borderRadius: "5px",
            fontSize: "16px",
            border: `2px solid ${landingPageLanguageButtonBorderColor}`,
            width: "100%",
          }}
        >
          English (United States)
        </button>
        <button
          style={{
            backgroundColor: "transparent",
            color: `${landingPageSelectedLanguageTextColor}`,
            padding: "10px 20px",
            borderRadius: "5px",
            fontSize: "16px",
            border: `2px solid ${landingPageSelectedLanguageButtonBorderColor}`,
            width: "100%",
          }}
        >
          Español (España)
        </button>
      </div>
    </div>
  );
};

export default LandingPage;
